export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 60,
    visible: !that.disabled && that.classification != 'S',
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_warehouse') || '客户仓库',
    field: 'whName',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    slots: { default: 'whName' },
    visible: that.classification == 'M',
  },
  {
    title: that.$l('table_label_deliveryDate') || '到货日期',
    field: 'deliveryDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 170,
    visible: that.classification == 'M',
  },
  {
    title: that.$l('table_label_plan_deliveryDate') || '计划到货日期',
    field: 'deliveryDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 170,
    visible: that.classification == 'R',
  },
  {
    title: that.$l('table_label_plan_beginShippingDate') || '计划最早出运日期',
    field: 'beginShippingDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 170,
    visible: that.classification != 'S',
  },
  {
    title: that.$l('table_label_plan_endShippingDate') || '计划截至出运日期',
    field: 'endShippingDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 170,
    visible: that.classification != 'S',
  },
  {
    title: that.$l('table_label_comfirm_deliveryDate') || '确认到货日期',
    field: 'comfirmDeliveryDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 170,
    visible: that.classification != 'S',
  },
  {
    title:
      that.$l('table_label_comfirm_beginShippingDate') || '确认最早出运日期',
    field: 'comfirmBeginShippingDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 170,
    visible: that.classification != 'S',
  },
  {
    title: that.$l('table_label_comfirm_endShippingDate') || '确认截至出运日期',
    field: 'comfirmEndShippingDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 170,
    visible: that.classification != 'S',
  },
  {
    title: that.$l('table_label_shippingDate') || '最早出货月',
    field: 'beginShippingDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    visible: that.classification == 'S',
  },
  {
    title: that.$l('table_label_planContainerQty') || '货柜数量',
    field: 'planContainerQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 80,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_planUnitQty') || '产品数量',
    field: 'planUnitQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 110,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_planSpecQty') || '规格数量',
    field: 'planSpecQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 110,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
    visible: that.classification == 'S',
  },
]
